import { NgModule, APP_INITIALIZER, ErrorHandler } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HeaderComponent } from '../header/header.component';
import { FooterComponent } from '../footer/footer.component';
import { SupportComponent } from '../support/support.component';
import { OPCComponent } from './opc.component';
import { ProductService } from '../shared/services/product.service';
import { GlobalVariable } from '../shared/global.variables';
import { PagerService } from '../shared/services/pager.service';
import { CommonService } from '../shared/services/common.service';
import { FormsModule } from '@angular/forms';
import { SearchResolver } from '../opc-app/searchresult/searchresolver';
import { AuthModule } from '../auth/auth.module';
import { RouterModule } from '@angular/router';
import { ProductFamilyComponent } from './productfamily/productfamily.component';
import { ProductLineComponent } from './productline/productline.component';
import { ProductLineDetailsComponent } from './productline/productlinedetails/productlinedetails.component';
import { PartGroupComponent } from './partgroup/partgroup.component';
import { PartCategoryComponent } from './partcategory/partcategory.component';
import { BreadCrumbComponent } from '../shared/components/breadcrumb/breadcrumb.component';
import { SearchResultComponent } from './searchresult/searchresult.component';
import { CardViewComponent } from '../shared/components/cardview/cardview.component';
import { PartComponent } from './part/part.component';
import { PartDetailsComponent } from './part/partdetails/partdetails.component';
import { OPCRoutingModule } from './opc.module.routing';
import { BrowserModule } from '@angular/platform-browser';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { OPCAdminModule } from '../opc-admin/opc-admin.module';
import { UserService } from '../shared/services/user.service';
import { AuthService } from '../auth/auth-service';
import { AuthGuard } from '../auth/auth-guard-service';
import { ErrorComponent } from './error/error.component';
import { AuthInterceptor } from '../auth/auth-interceptor';
import { ConfigService } from '../shared/services/configService';
import { GlobalErrorHandler } from '../shared/services/errorhandling.service';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { PartService } from '../shared/services/part.service';
import { NotificationService } from '../shared/services/notification.service';
import { PartCategoryService } from '../shared/services/partcategory.service';
import { PartGroupService } from '../shared/services/partgroup.service';
import { ExportService } from '../shared/services/export.service';
import { ColorService } from '../shared/services/color.service';
import { CallbacksComponent } from '../../app/callback/callbacks.component';
import { IdentityGuard } from '../auth/identity-service';
import { NgxSpinnerModule } from 'ngx-spinner';
import { LogoutComponent } from '../logout/logout.component';


@NgModule({
  declarations: [
    HeaderComponent,
    FooterComponent,
    SupportComponent,
    OPCComponent,
    ProductFamilyComponent,
    ProductLineComponent,
    ProductLineDetailsComponent,
    PartGroupComponent,
    PartCategoryComponent,
    BreadCrumbComponent,
    SearchResultComponent,
    CardViewComponent,
    PartComponent,
    PartDetailsComponent,
    ErrorComponent,
    CallbacksComponent,
    LogoutComponent
  ],
  imports: [
    CommonModule,
    AuthModule,
    RouterModule,
    BrowserModule,
    HttpClientModule,
    FormsModule,
    OPCAdminModule,
    OPCRoutingModule,
    BrowserAnimationsModule,
    NgxSpinnerModule
  ],
  exports: [
    OPCComponent
  ],
  providers: [
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthInterceptor,
      multi: true
    },
    ConfigService,
    {
      provide: APP_INITIALIZER,
      useFactory: (configService: ConfigService) => function () { return configService.loadSettings(); },
      deps: [ConfigService],
      multi: true
    },
    {
      provide: ErrorHandler,
      useClass: GlobalErrorHandler
    },
    ProductService,
    PartService,
    PartCategoryService,
    PartGroupService,
    GlobalVariable,
    PagerService,
    CommonService,
    SearchResolver,
    UserService,
    AuthService,
    AuthGuard,
    NotificationService,
    ExportService,
    ColorService,
    IdentityGuard
  ]
})
export class OPCModule {

}



// WEBPACK FOOTER //
// ./src/opc/opc-app/opc.module.ts